// Articles Block Image Swapping
jQuery(document).ready(function ($) {
  // ── WooCommerce cart count live update ──
  // After an AJAX add-to-cart, WooCommerce fires "added_to_cart" with the
  // latest cart fragments. Update every .header-cart-count span immediately
  // so the user sees the new count without a page reload.
  $(document.body).on("added_to_cart", function (e, fragments) {
    if (fragments && fragments[".cart-count"]) {
      $(".cart-count").replaceWith(fragments[".cart-count"]);
    }
  });

  const articleItems = $(".article-item");
  const imageItems = $(".article-image-item");

  if (articleItems.length && imageItems.length) {
    // Add hover event listeners to each article item
    articleItems.each(function () {
      $(this).on("mouseenter", function () {
        const index = $(this).attr("data-index");

        // Remove active class from all images
        imageItems.removeClass("active");

        // Add active class to corresponding image
        const targetImage = $(`.article-image-item[data-index="${index}"]`);
        if (targetImage.length) {
          targetImage.addClass("active");
        }
      });
    });

    // Optional: Reset to first image when mouse leaves the articles area
    const articlesWrapper = $(".articles-wrapper");
    if (articlesWrapper.length) {
      articlesWrapper.on("mouseleave", function () {
        // Remove active class from all images
        imageItems.removeClass("active");

        // Set first image as active
        const firstImage = $(".article-image-item[data-index='0']");
        if (firstImage.length) {
          firstImage.addClass("active");
        }
      });
    }
  }

  // Header Search mobile toggle
  const $mobileSearchIcon = $(".mobile-search-icon");
  const $mobileSearchForm = $(".mobile-search-form");

  $mobileSearchIcon.on("click", function () {
    $mobileSearchForm.toggleClass("active");
  });

  // Header carousel for mobile

  function initFeaturesCarousel() {
    if ($(window).width() <= 1280) {
      if (!$(".features-carousel").hasClass("slick-initialized")) {
        $(".features-carousel").slick({
          infinite: true,
          slidesToShow: 1,
          slidesToScroll: 1,
          autoplay: true,
          autoplaySpeed: 3000,
          arrows: true,
          dots: false,
        });
      }
    } else {
      if ($(".features-carousel").hasClass("slick-initialized")) {
        $(".features-carousel").slick("unslick");
      }
    }
  }

  // Initialize on page load
  initFeaturesCarousel();

  // Handle window resize with debounce
  let carouselResizeTimer;
  $(window).on("resize", function () {
    clearTimeout(carouselResizeTimer);
    carouselResizeTimer = setTimeout(function () {
      initFeaturesCarousel();
    }, 250);
  });

  // Tabbed content functionaity
  $(".tabbed-content-block .tab-button").on("click", function () {
    const targetTab = $(this).data("tab");

    // Remove active class from all buttons and contents within this block
    $(".tabbed-content-block .tab-button").removeClass("active");
    $(".tabbed-content-block .tabbed-content-item").removeClass("active");

    // Add active class to clicked button and corresponding content
    $(this).addClass("active");
    $(`.tabbed-content-block [data-tab-content="${targetTab}"]`).addClass(
      "active",
    );
  });

  // Mobile tab sheet functionality
  (function ($) {
    const MOBILE_BP = 768;

    const isMobile = () => window.innerWidth <= MOBILE_BP;

    $(".tabbed-content-block").each(function () {
      const $block = $(this);
      const $topTabs = $block.find(".tab-navigation .tab-button");
      const $panels = $block.find(".tabbed-content-item");

      const $sheet = $block.find(".tabbed-mobile-sheet");
      const $sheetTabs = $sheet.find("[data-sheet-tabs]");
      const $sheetContent = $sheet.find("[data-sheet-content]");
      const $sheetClose = $sheet.find("[data-sheet-close]");

      let activeIndex = null;

      // --- Build duplicated tabs inside sheet ---
      const buildSheetTabs = () => {
        $sheetTabs.empty();

        $topTabs.each(function () {
          const $btn = $(this);
          const $clone = $btn.clone(false);

          $clone.removeClass("active");

          $clone.on("click", function () {
            const index = $(this).data("tab");
            activateSheetTab(index);
          });

          $sheetTabs.append($clone);
        });
      };

      // --- Activate tab inside sheet ---
      const activateSheetTab = (index) => {
        activeIndex = index;

        // set active states
        $sheetTabs.find(".tab-button").removeClass("active");
        $sheetTabs
          .find(`.tab-button[data-tab="${index}"]`)
          .addClass("active")
          .get(0)
          ?.scrollIntoView({ behavior: "smooth", inline: "center" });

        $topTabs.removeClass("active");
        $topTabs
          .filter(`[data-tab="${index}"]`)
          .addClass("active")
          .get(0)
          ?.scrollIntoView({ behavior: "smooth", inline: "center" });

        // inject content
        const $panel = $panels.filter(`[data-tab-content="${index}"]`);
        $sheetContent.html($panel.html());

        // reset scroll
        $sheetContent.scrollTop(0);
      };

      // --- Open sheet ---
      const openSheet = (index) => {
        buildSheetTabs();
        activateSheetTab(index);

        $sheet.attr("data-open", "true");
        $("html, body").css("overflow", "hidden");
      };

      // --- Close sheet ---
      const closeSheet = () => {
        $sheet.removeAttr("data-open");
        $("html, body").css("overflow", "");
      };

      // --- Intercept tab clicks on mobile ---
      $topTabs.on("click", function (e) {
        if (!isMobile()) return;

        e.preventDefault();
        e.stopImmediatePropagation();

        openSheet($(this).data("tab"));
      });

      // --- Close actions ---
      $sheetClose.on("click", closeSheet);

      $(document).on("keydown", function (e) {
        if (e.key === "Escape") closeSheet();
      });

      // --- Reset if resized to desktop ---
      $(window).on("resize", function () {
        if (!isMobile()) closeSheet();
      });
    });
  })(jQuery);

  //related products mobile carousel
  (function ($) {
    const $carousel = $(".related-products-grid");
    const breakpoint = 980;

    function toggleRelatedCarousel() {
      if (window.innerWidth < breakpoint) {
        if (!$carousel.hasClass("slick-initialized")) {
          $carousel.slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            dots: false,
            infinite: false,
            swipeToSlide: true,
            mobileFirst: true,
            adaptiveHeight: true,
          });
        }
      } else {
        if ($carousel.hasClass("slick-initialized")) {
          $carousel.slick("unslick");
        }
      }
    }

    $(document).ready(toggleRelatedCarousel);
    $(window).on("resize orientationchange", toggleRelatedCarousel);
  })(jQuery);

  // Accordion Functionality on media txt and product pages
  const $items = $(".accordion-item");
  $items.each(function () {
    const $item = $(this);

    $item.on("click", function (e) {
      if ($(this).open === "true") {
        $(this).open = "false";
      } else {
        $items.not($(this)).prop("open", false);
        $(this).open = "true";
      }
    });
  });
});

jQuery(document).ready(function ($) {
  var $slider = $(".product-hero-slider");

  if (!$slider.length) return;

  // Only slick if more than 1 slide
  if ($slider.children().length > 1) {
    $slider.slick({
      slidesToShow: 2,
      slidesToScroll: 1,
      arrows: true,
      dots: true,
      prevArrow: $(".slider-nav.single-product-nav .slick-prev"),
      nextArrow: $(".slider-nav.single-product-nav .slick-next"),
      appendDots: $(".slider-nav.single-product-nav .slider-dots"),
      infinite: true,
      adaptiveHeight: false,
      autoplay: false,
      responsive: [
        {
          breakpoint: 980,
          settings: {
            slidesToShow: 1,
          },
        },
      ],
    });
  }
});

// Footer Details Responsive Behavior
jQuery(document).ready(function ($) {
  function handleFooterDetails() {
    const footerDetails = $(".footer-details-wrapper");

    if (window.innerWidth > 768) {
      // Desktop: Always keep open and prevent closing
      footerDetails.each(function () {
        this.open = true;
      });

      // Prevent clicking on summary from closing
      $(".footer-details-wrapper summary")
        .off("click.footerToggle")
        .on("click.footerToggle", function (e) {
          if (window.innerWidth > 768) {
            e.preventDefault();
            e.stopPropagation();
          }
        });
    } else {
      // Mobile: Remove click prevention and close all initially
      $(".footer-details-wrapper summary").off("click.footerToggle");

      // Close all on mobile by default
      footerDetails.each(function () {
        this.open = false;
      });
    }
  }

  // Run on load
  handleFooterDetails();

  // Run on resize with debounce
  let resizeTimer;
  $(window).on("resize", function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(handleFooterDetails, 250);
  });
});

//Product page caorousel
jQuery(document).ready(function ($) {
  // Initialize Slick Carousel with nav
  $(".product-slick-carousel").slick({
    slidesToShow: 2,
    slidesToScroll: 1,
    asNavFor: "#main-product-image",
    dots: false,
    centerMode: false,
    focusOnSelect: true,
    arrows: false,
    infinite: false,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
        },
      },
    ],
  });

  // Gallery item click handler
  $(".gallery-item").on("click", function () {
    var newImageSrc = $(this).data("full");
    var newImageAlt = $(this).find("img").attr("alt");

    $("#main-product-image").attr("src", newImageSrc).attr("alt", newImageAlt);
  });
});

jQuery(document).ready(function ($) {
  const $offscreenInfo = $(".offscreen-info");
  const $npsInfo = $(".nps-info");

  $npsInfo.on("click", function (e) {
    e.stopPropagation();
    $offscreenInfo.toggleClass("open");
  });

  // Close when clicking outside
  $(document).on("click", function (e) {
    if (!$(e.target).closest(".offscreen-info, .nps-info").length) {
      $offscreenInfo.removeClass("open");
    }
  });

  // Prevent clicks inside offscreen-info from closing it
  $offscreenInfo.on("click", function (e) {
    e.stopPropagation();
  });
});

// Product page sticky bar functionality
jQuery(document).ready(function ($) {
  const $stickyBar = $("#stickyBottomBar");
  const $backToTopBtn = $("#backToTopBtn");
  const $productHeader = $(".single-product-header");

  if ($stickyBar.length && $backToTopBtn.length && $productHeader.length) {
    // Show/hide sticky bar when product header is out of view
    $(window).on("scroll", function () {
      const headerBottom =
        $productHeader.offset().top + $productHeader.outerHeight();
      const scrollPosition = $(window).scrollTop();

      if (scrollPosition > headerBottom) {
        $stickyBar.addClass("visible");
      } else {
        $stickyBar.removeClass("visible");
      }
    });

    // Back to top functionality
    $backToTopBtn.on("click", function () {
      $("html, body").animate(
        {
          scrollTop: 0,
        },
        400,
      );
    });
  }
});

//mobile menu functions
// jQuery(document).ready(function ($) {
//   var $drawer = $("#mm-drawer");
//   var $toggle = $(".mm-toggle");
//   var $overlay = $(".mm-overlay");
//   var $close = $drawer.find(".mm-close");
//   var $panels = $drawer.find(".mm-panels");

//   if (!$drawer.length || !$toggle.length || !$overlay.length || !$panels.length)
//     return;

//   var panelStack = ["root"];

//   function setActivePanel(panelId) {
//     var $all = $panels.find(".mm-panel");
//     $all.removeClass("mm-panel--active mm-panel--left");

//     var $active = $panels.find(".mm-panel[data-panel='" + panelId + "']");
//     if (!$active.length) return;

//     // mark previous as left (nice slide-back feel)
//     if (panelStack.length > 1) {
//       var prevId = panelStack[panelStack.length - 2];
//       $panels
//         .find(".mm-panel[data-panel='" + prevId + "']")
//         .addClass("mm-panel--left");
//     }

//     $active.addClass("mm-panel--active");
//   }

//   function openMenu() {
//     $drawer.addClass("is-open").attr("aria-hidden", "false");
//     $overlay.prop("hidden", false);
//     $("body").addClass("mm-locked");
//     $toggle.attr("aria-expanded", "true");
//   }

//   function closeMenu() {
//     $drawer.removeClass("is-open").attr("aria-hidden", "true");
//     $overlay.prop("hidden", true);
//     $("body").removeClass("mm-locked");
//     $toggle.attr("aria-expanded", "false");

//     panelStack = ["root"];
//     setActivePanel("root");
//   }

//   $toggle.on("click", openMenu);
//   $overlay.on("click", closeMenu);
//   $close.on("click", closeMenu);

//   function makePanel(id, title, $submenuUL) {
//     var $panel = $("<div/>", { class: "mm-panel", "data-panel": id });

//     var $back = $("<button/>", {
//       class: "mm-back",
//       type: "button",
//       html: "<span>‹</span> Back",
//     });
//     $back.on("click", function () {
//       if (panelStack.length > 1) panelStack.pop();
//       setActivePanel(panelStack[panelStack.length - 1]);
//     });

//     var $list = $submenuUL.clone(true, true);
//     $list.addClass("mm-submenu");

//     $panel.append($back, $list);
//     $panels.append($panel);

//     return $panel;
//   }

//   // Converts a list's direct children to "row + chevron", recursively for new panels.
//   function convertList($ul) {
//     $ul.children("li").each(function () {
//       var $li = $(this);
//       var $a = $li.children("a").first();
//       var $submenu = $li.children("ul").first();

//       if (!$a.length || !$submenu.length) return;

//       var panelId = "p-" + Math.random().toString(16).slice(2);
//       makePanel(panelId, $.trim($a.text()), $submenu);

//       // Build row: [link navigates] [chevron opens submenu]
//       var $row = $("<div/>", { class: "mm-row" });
//       var $link = $a.clone(true, true); // keep navigation
//       var $next = $("<button/>", {
//         class: "mm-next",
//         type: "button",
//         text: "›",
//       }).attr("aria-label", "Open " + $.trim($a.text()) + " submenu");

//       $next.on("click", function (e) {
//         e.preventDefault();
//         e.stopPropagation();

//         var currentId =
//           $panels.find(".mm-panel--active").data("panel") || "root";
//         if (panelStack[panelStack.length - 1] !== currentId)
//           panelStack.push(currentId);

//         panelStack.push(panelId);
//         setActivePanel(panelId);

//         // Convert nested items inside this panel once
//         var $newPanel = $panels.find(".mm-panel[data-panel='" + panelId + "']");
//         var $newUL = $newPanel.find("ul").first();

//         if ($newUL.length && !$newUL.data("converted")) {
//           $newUL.data("converted", 1);
//           convertList($newUL);
//         }
//       });

//       $row.append($link, $next);

//       // Replace li contents with row and remove submenu at this level
//       $li.empty().append($row);
//     });
//   }

//   // Init from root panel's UL
//   var $rootPanel = $panels.find(" .mm-panel[data-panel='root']");
//   var $rootUL = $rootPanel.find("ul").first();

//   if (!$rootUL.length) return;

//   $rootUL.data("converted", 1);
//   convertList($rootUL);
//   setActivePanel("root");

//   // ESC closes
//   $(document).on("keydown", function (e) {
//     if (e.key === "Escape" && $drawer.hasClass("is-open")) closeMenu();
//   });
// });
